import { Directive, ElementRef, HostListener, OnDestroy, OnInit } from '@angular/core';

@Directive({
    selector: '[tf-search-header-mobile-space]',
})
export class TfSearchHeaderMobileSpaceDirective implements OnInit, OnDestroy {

    constructor(private modal: ElementRef = null) {
    }

    ngOnInit() {
        this.setHeaderHeight();
    }

    ngOnDestroy() {
        document.body.style.overflow = "auto";
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.setHeaderHeight();
    }

    setHeaderHeight() {
        if (this.modal) {
            const headerHeight = (document.getElementById('hfGlobalCommerceBar')?.offsetHeight + document.getElementById('header-offer-bar')?.offsetHeight || 95);

            this.modal.nativeElement.style.top = `${headerHeight}px`;
            document.body.style.overflow = "hidden";
        }
    }
}
